/**
 * Allocate app — /apps/allocate/*
 *
 * One job: a budget owner wants to split a finite resource across competing
 * asks — and show their work. Three screens (C Mode): the Envelope (what there
 * is and what's asking for it), the Trade (participants spend it), the Split
 * (the distribution plus the rationale that makes it defensible).
 *
 * Rides the canonical session machinery: an allocation IS a session run with an
 * allocation-shaped method (Buy-a-Feature by default, Cost-of-Delay when the
 * room needs rigor over engagement). No new tables, no new RPCs.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import EnvelopeScreen from './EnvelopeScreen';
import SplitScreen from './SplitScreen';

export default function AllocateApp() {
  const app = getAppDefinition('allocate')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<EnvelopeScreen />} />
        <Route path=":sessionId" element={<SplitScreen />} />
        <Route path="*" element={<Navigate to="/apps/allocate" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
